export const companyImprint = "https://www.rentujemy.pl/imprint";

export const termsLink = "https://www.rentujemy.pl/terms-of-service";

export const privacyLink = "https://www.rentujemy.pl/privacy-policy";

export const instagramLink = "https://www.instagram.com/rentujemy/";

export const facebookLink = "https://www.facebook.com/rentujemy/";
